/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next/";
import { Grid, IconButton, Typography } from "@material-ui/core";
//custom libraries
import { useCustomerDetails, useSidebar } from "../hooks";
import { CustomerInformation, CustomerDetailForm } from "../containers";
import { ContentSection, Alert, SidebarSection } from "../components";
import OrganizationInformationSection from "../containers/organization-information";
import Snackbar from "@material-ui/core/Snackbar";
import { CloseCircleOutlined } from "@ant-design/icons";

export default function CustomerDetail() {
  const {
    changeCustomerStatus,
    clickResetPassword,
    cusinfo,
    orgInfo,
    selectedStore,
    setCusinfo,
    handleChange,
    clickSubmit,
    displayAlert,
    canSave,
    editFormData,
    initializeEditForm,
    openMsg,
    setOpenMsg,
  } = useCustomerDetails();
  const { t } = useTranslation();
  const {
    showEditForm,
    setShoweditForm,
    showCustomerControl,
    setShowCustomerControl,
  } = useSidebar();

  React.useEffect(() => {
    setShowCustomerControl(false);
  }, [setShowCustomerControl]);

  const handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenMsg(false);
  };

  return (
    <Grid container alignItems="stretch" className="min-content-height">
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={openMsg}
          autoHideDuration={6000}
          onClose={handleClose}
          message="La contraseña del cliente se ha restablecido satisfactoriamente."
          action={
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}>
                <CloseCircleOutlined></CloseCircleOutlined>
              </IconButton>
            </React.Fragment>
          }
        />
      </div>
      <SidebarSection>
        <CustomerDetailForm
          {...{
            changeCustomerStatus,
            clickResetPassword,
            cusinfo,
            showEditForm,
            setShoweditForm,
          }}
        />
      </SidebarSection>
      <ContentSection>
        <Grid
          container
          direction="column"
          justify="space-between"
          alignItems="center">
          <Grid container spacing={2}>
            <Grid item xs={selectedStore.type === "BMH" ? 6 : 12}>
              <CustomerInformation
                {...{
                  cusinfo,
                  setCusinfo,
                  showEditForm,
                  setShoweditForm,
                  handleChange,
                  clickSubmit,
                  changeCustomerStatus,
                  showCustomerControl,
                  displayAlert,
                  canSave,
                  editFormData,
                  initializeEditForm,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              {selectedStore.type === "BMH" && (
                <OrganizationInformationSection address={orgInfo} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </ContentSection>
    </Grid>
  );
}
